export default __webpack_public_path__ + "static/logo-reserve-small-b61258ad7b283d52a161c22f827b43c3.svg";